import { Component } from '@angular/core';
import { Dialog } from './dialog';
import { trigger, state, style, animate, transition } from '@angular/animations';

export interface ConfirmDialogOptions {
  title: string
  message: string
  confirm_button_text: string
  confirm_button_class: string
}

/**
 * Confirmation dialog
 */
@Component({
  templateUrl: './confirm-dialog.component.html',
  host: {'(window:keydown)': 'hotkeys($event)'},
  styles: [
    `.dialog-container {
      display: block;
      position: fixed;
      z-index: 300;
      width: 100%;
      left: 0;
    }`
  ],
  animations: [
    trigger(
      'openState',
      [
        state(
          'open',
          style({
            top: '0px'
          })
        ),
        state(
          'closed',
          style({
            top: '-210px'
          })
        ),
        transition('closed => open', animate('400ms ease-out')),
        transition('open => closed', animate('400ms ease-in')),
      ]
    ),
  ]
})
export class ConfirmDialogComponent implements Dialog {
  state = 'closed';

  title: string
  message: string
  confirm_button_text: string
  confirm_button_class: string
  onConfirm: (result: boolean) => void

  confirm(result: boolean) {
    this.onConfirm(result);
  }

  hotkeys(event: KeyboardEvent){

    switch(event.keyCode) {
      // Escape key
      case 27:
        this.confirm(false);
        break;
      // Enter key
      case 13:
        this.confirm(true);
        break;
    }
  }
}

